import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import { c as y } from "./index.CxSWpsOB.js";
const x = ({
  className: m,
  spacing: t = 32,
  ...w
}) => /* @__PURE__ */ r.jsx("hr", { className: y("tw-border-gray-300 tw-h-[1px] tw-w-full tw-block", {
  "tw-my-0": t === 0,
  "tw-my-8": t === 8,
  "tw-my-12": t === 12,
  "tw-my-16": t === 16,
  "tw-my-24": t === 24,
  "tw-my-32": t === 32,
  "tw-my-40": t === 40,
  "tw-my-48": t === 48,
  "tw-my-56": t === 56,
  "tw-my-64": t === 64
}, m), ...w });
export {
  x as D
};
//# sourceMappingURL=Divider.CmCxrw3f.js.map
